module.exports = __webpack_public_path__ + "img/visa-logo.641e79e4.svg";